import { EditTemplateEngageStepInterface } from "./interfaces/editTemplateEngageStepInterface";
import { EngageFormInterface } from "./interfaces/engageFormInterface";
import { EngageStepInterface } from "./interfaces/engageStepInterface";
import { OverviewEngageStepInterface } from "./interfaces/overviewEngageStepInterface";
import { SelectChannelEngageStepInterface } from "./interfaces/selectChannelEngageStepInterface";
import { SelectTemplateEngageStepInterface } from "./interfaces/selectTemplateEngageStepInterface";
import { SelectContactListStepInterface } from "./interfaces/selectContactListStepInterface";
import { NameEngageStepInterface } from "./interfaces/nameEngageStepInterface";
import { ScheduleInterface } from "@/views/modules/engage/interfaces/scheduleInterface";

interface WindowOrWorkerGlobalScope {
    // @ts-ignore
    structuredClone(value: any, options?: StructuredSerializeOptions): any;
}

// @ts-ignore
declare function structuredClone(value: any, options?: StructuredSerializeOptions): any;

const selectTemplateStepBlank: any = {
    id: 1,
    order: 3,
    name: "engage.select-template",
    isDone: false,
    isActive: false,
    nextStepId: 2,
    previousStepId: 4,
    independent: true,
    action: null,
    persist: true,
    type: "next",
    isHidden: false,
    template: null,
    channelId: null,
};

const editTemplateStepBlank: any = {
    id: 2,
    order: 4,
    name: "engage.edit-message",
    isDone: false,
    isActive: false,
    nextStepId: 3,
    previousStepId: 1,
    independent: false,
    action: null,
    persist: true,
    type: "next",
    isHidden: false,
    template: null,
    variables: new Map(),
};

const selectContactListStepBlank: any = {
    id: 3,
    order: 5,
    name: "engage.select-contact-list",
    isDone: false,
    isActive: false,
    nextStepId: 8,
    previousStepId: 1,
    independent: true,
    action: null,
    persist: true,
    type: "next",
    isHidden: false,
    contactList: null,
    limit: null,
    currentContactsValue: null,
    isLimitExceeded: true,
};

const createContactListStepBlank: any = {
    id: 6,
    order: 999,
    name: "engage.create-contact-list",
    type: "next",
    isDone: false,
    isActive: false,
    isHidden: true,
    nextStepId: 3,
    previousStepId: 3,
    independent: true,
    action: null,
    persist: false,
};

const selectChannelStepBlank: any = {
    id: 4,
    order: 2,
    name: "engage.select-channel",
    isDone: false,
    isActive: false,
    nextStepId: 1,
    previousStepId: 7,
    independent: true,
    action: null,
    persist: true,
    type: "next",
    isHidden: false,
    channel: null,
};

const scheduleStepBlank: any = {
    id: 8,
    order: 6,
    name: "engage.schedule",
    isDone: false,
    isActive: false,
    nextStepId: 5,
    previousStepId: 4,
    action: null,
    persist: true,
    isHidden: false,
    dateTime: null,
};

const overviewStepBlank: any = {
    id: 5,
    order: 7,
    name: "engage.overview",
    type: "send",
    isDone: false,
    isActive: false,
    nextStepId: null,
    previousStepId: 8,
    independent: true,
    action: null,
    persist: false,
    isHidden: false,
    editedTemplate: null,
    selectedContactList: null,
    selectedChannel: null,
};

const nameEngageStepBlank: any = {
    id: 7,
    order: 1,
    name: "engage.name-engage",
    isDone: false,
    isActive: true,
    nextStepId: 4,
    previousStepId: null,
    independent: true,
    action: null,
    persist: true,
    isHidden: false,
    messageName: "",
    description: "",
};

export function getNewForm(): EngageStage {
    const selectTemplateStep: SelectTemplateEngageStepInterface = structuredClone(selectTemplateStepBlank);
    const editTemplateStep: EditTemplateEngageStepInterface = structuredClone(editTemplateStepBlank);
    const selectContactListStep: SelectContactListStepInterface = structuredClone(selectContactListStepBlank);
    const createContactListStep: EngageStepInterface = structuredClone(createContactListStepBlank);
    const selectChannelStep: SelectChannelEngageStepInterface = structuredClone(selectChannelStepBlank);
    const scheduleStep: ScheduleInterface = structuredClone(scheduleStepBlank);
    const overviewStep: OverviewEngageStepInterface = structuredClone(overviewStepBlank);
    const nameEngageStep: NameEngageStepInterface = structuredClone(nameEngageStepBlank);

    overviewStep.editedTemplate = editTemplateStep;
    overviewStep.selectedContactList = selectContactListStep;
    overviewStep.selectedChannel = selectChannelStep;
    overviewStep.nameEngage = nameEngageStep;
    overviewStep.schedule = scheduleStep;

    return {
        currentStepId: nameEngageStep.id,
        selectTemplateStep,
        editTemplateStep,
        selectContactListStep,
        createContactListStep,
        selectChannelStep,
        scheduleStep,
        overviewStep,
        nameEngageStep,
    };
}

export function reconstructForm(stage: EngageStage): EngageFormInterface {
    stage.selectTemplateStep.validate = () => {
        stage.selectTemplateStep.isDone = Boolean(stage.selectTemplateStep.template);
    };
    stage.editTemplateStep.validate = () => {
        stage.editTemplateStep.isDone =
            Boolean(stage.editTemplateStep.template) &&
            !stage.editTemplateStep.template?.content.match(/{{\d+}}/) &&
            Boolean(!stage.editTemplateStep.template?.mediaType || stage.editTemplateStep.attachments?.length);
    };
    stage.selectContactListStep.validate = () => {
        stage.selectContactListStep.isDone =
            Boolean(stage.selectContactListStep.contactList?.id) && !stage.selectContactListStep.isLimitExceeded;
        stage.selectContactListStep.isLimitExceeded =
            stage.selectContactListStep.contactsLimit !== null &&
            stage.selectContactListStep.currentContactsValue !== null &&
            stage.selectContactListStep.messagesLimit !== null &&
            stage.selectContactListStep.currentMessagesValue !== null &&
            stage.selectContactListStep.isLimitExceeded;
    };

    stage.selectChannelStep.validate = () => {
        stage.selectChannelStep.isDone = Boolean(stage.selectChannelStep.channel);
    };

    stage.nameEngageStep.validate = () => {
        stage.nameEngageStep.isDone =
            Boolean(stage.nameEngageStep.messageName.trim()) && stage.nameEngageStep.messageName.length <= 50;
    };

    // not persisted steps need to be recreated from blank each time
    stage.createContactListStep = structuredClone(createContactListStepBlank);
    stage.createContactListStep.validate = () => {
        stage.createContactListStep.isDone = false;
    };

    stage.overviewStep = structuredClone(overviewStepBlank);
    stage.overviewStep.validate = () => {
        stage.overviewStep.isDone = true;
    };

    if (stage.currentStepId === stage.overviewStep.id) {
        stage.overviewStep.isActive = true;
        stage.overviewStep.validate();
    }

    stage.scheduleStep.validate = () => {
        stage.scheduleStep.isDone = true;
    };

    stage.overviewStep.editedTemplate = stage.editTemplateStep;
    stage.overviewStep.selectedContactList = stage.selectContactListStep;
    stage.overviewStep.selectedChannel = stage.selectChannelStep;
    stage.overviewStep.nameEngage = stage.nameEngageStep;
    stage.overviewStep.schedule = stage.scheduleStep;

    const form = {
        steps: [
            stage.selectTemplateStep,
            stage.editTemplateStep,
            stage.selectContactListStep,
            stage.createContactListStep,
            stage.selectChannelStep,
            stage.scheduleStep,
            stage.overviewStep,
            stage.nameEngageStep,
        ],
    };

    form.steps.sort((stepA, stepB) => stepA.order - stepB.order);

    return form;
}

type EngageStage = {
    currentStepId: number;
    selectTemplateStep: SelectTemplateEngageStepInterface;
    editTemplateStep: EditTemplateEngageStepInterface;
    selectContactListStep: SelectContactListStepInterface;
    createContactListStep: EngageStepInterface;
    selectChannelStep: SelectChannelEngageStepInterface;
    scheduleStep: ScheduleInterface;
    overviewStep: OverviewEngageStepInterface;
    nameEngageStep: NameEngageStepInterface;
};
